import { Injectable } from '@angular/core';
import { DateAdapter, NativeDateAdapter } from '@angular/material/core';
import { DateRange, MatDateRangeSelectionStrategy } from '@angular/material/datepicker';
import { PeriodTypes } from '@shared/components/scheduler-period-picker/filterTypes';
import { addDays, endOfMonth, endOfWeek, startOfMonth, startOfWeek } from 'date-fns';
import { BehaviorSubject } from 'rxjs';

import { legacyParse } from '@date-fns/upgrade/v2';

@Injectable()
export class PeriodCalendarService<D> implements MatDateRangeSelectionStrategy<D> {
  constructor(private _dateAdapter: DateAdapter<D>) {}
  selectedPeriod$: BehaviorSubject<string> = new BehaviorSubject<string>('day');

  selectionFinished(date: D | null): DateRange<D> {
    return this._createCustomRange(date);
  }

  createPreview(activeDate: D | null): DateRange<D> {
    return this._createCustomRange(activeDate);
  }

  private _createCustomRange(date: D | null): DateRange<D> {
    const selectedPeriodValue = this.selectedPeriod$.value;
    let dateRange: DateRange<D>;
    let start: any, end: any;

    if (date) {
      switch (selectedPeriodValue) {
        case PeriodTypes.Day:
          start = date;
          end = date;
          dateRange = new DateRange<D>(start, end);
          break;
        case PeriodTypes.Week:
          start = startOfWeek(legacyParse(new Date(date.toString())), { weekStartsOn: 1 });
          end = endOfWeek(legacyParse(new Date(date.toString())), { weekStartsOn: 1 });
          dateRange = new DateRange<D>(start, end);
          break;
        case PeriodTypes.TwoWeeks:
          start = startOfWeek(legacyParse(new Date(date.toString())), { weekStartsOn: 1 });
          end = endOfWeek(legacyParse(new Date(date.toString())), { weekStartsOn: 1 });
          end = addDays(legacyParse(end), 7);
          dateRange = new DateRange<D>(start, end);
          break;
        case PeriodTypes.FourWeeks:
          start = startOfWeek(legacyParse(new Date(date.toString())), { weekStartsOn: 1 });
          end = endOfWeek(legacyParse(new Date(date.toString())), { weekStartsOn: 1 });
          end = addDays(legacyParse(end), 21);
          dateRange = new DateRange<D>(start, end);
          break;
        case PeriodTypes.Month:
          start = startOfMonth(legacyParse(new Date(date.toString())));
          end = endOfMonth(legacyParse(new Date(date.toString())));
          dateRange = new DateRange<D>(start, end);
          break;
      }
    } else {
      dateRange = new DateRange<D>(null, null);
    }

    return dateRange;
  }
}

@Injectable()
export class MyDateAdapter extends NativeDateAdapter {
  // First day of week is Monday
  getFirstDayOfWeek(): number {
    return 1;
  }
}
